import { useReferralsContext } from '@user/components/Referrals/context'
import { setOtherActionCreator } from '@user/components/Referrals/state'
import { referralDataMapperModelToDTO } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralDrawer/hooks/utils'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'
import { useCallback, useMemo } from 'react'

export function useHandlers({ formVariant }: ReferralFormProps) {
  const [state, dispatch] = useReferralsContext()
  const context = useFormikContext<ILeadFormModel>()

  const isInline = useMemo<boolean>(() => {
    return formVariant === ReferralFormVariant.Inline
  }, [formVariant])

  const isInValid = useMemo<boolean>(() => {
    return Boolean(
      isInline && context?.errors?.referral && context?.touched?.referral,
    )
  }, [context?.errors?.referral, context?.touched?.referral, isInline])

  const handleOtherChange = useCallback(
    (event) => {
      const value = event.target.value.trimStart() || ''
      dispatch(setOtherActionCreator(value))
      if (isInline) {
        const model = referralDataMapperModelToDTO({
          ...state,
          referralOther: value,
        })
        context?.setFieldValue('referral', model)
      }
    },
    [context, dispatch, isInline, state],
  )

  return {
    handleOtherChange,
    isInValid,
    error: isInValid ? context?.errors?.referral : undefined,
  }
}
